var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluentCallWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94509 7.48335L8.56675 8.72001C8.74895 9.34365 9.00346 9.94383 9.32509 10.5083C9.66057 11.0687 10.0648 11.585 10.5284 12.045L12.3134 11.495C13.3134 11.1867 14.4051 11.5033 15.0701 12.295L16.0868 13.505C16.4984 13.9908 16.7047 14.6177 16.6621 15.2529C16.6195 15.8882 16.3312 16.4819 15.8584 16.9083C14.2001 18.4217 11.6468 18.9333 9.73509 17.4317C8.0542 16.1096 6.63249 14.4878 5.54175 12.6483C4.44825 10.8179 3.71612 8.79468 3.38509 6.68835C3.01842 4.31835 4.75342 2.42168 6.91676 1.77501C8.20676 1.38835 9.58342 2.05168 10.0568 3.28835L10.6151 4.74668C10.9818 5.70668 10.7184 6.79001 9.94509 7.48335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentCallWhite);
export default __webpack_public_path__ + "static/media/fluent_call_white.2e02a3d152a4c659448c339955ae24e6.svg";
export { ForwardRef as ReactComponent };